export default __webpack_public_path__ + "static/media/41t.54245445.jpg";